export default __webpack_public_path__ + "static/media/ranes.389a6672.jpg";